import PageLoadingState from '@/components/ui/PageLoadingState';
import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/features/Auth/model/authStore';

interface ProtectedRouteProps {
  children: ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const initialized = useAuthStore((s) => s.initialized);
  const location = useLocation();
  const from = `${location.pathname}${location.search}${location.hash}`;

  if (!initialized) {
    console.warn('[DEBUG][ProtectedRoute] initialized is false, pathname:', location.pathname);
    return <PageLoadingState label="Проверка доступа..." />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from }} replace />;
  }

  return <>{children}</>;
}
